export default "__VITE_ASSET__BIbNBKAq__"